import { useToken } from '../node_modules/@zooplus/myaccount-utils/dist/es/hooks/useToken/useToken.js';
import { useCustomerConfiguration } from '../node_modules/@zooplus/myaccount-utils/dist/es/hooks/useCustomerConfiguration/useCustomerConfiguration.js';

function useAppConfiguration({ domain }) {
    const { payload, token } = useToken();
    return useCustomerConfiguration({
        caller: 'header-account-flyout',
        domain,
        customerId: payload?.customerId,
        token,
        initialCustomerConfiguration: {
            displayWishlist: true,
            displayCoupons: false,
            couponsCount: 0,
        },
        getStateFromCustomerConfiguration: (customerConfig, initialCustomerConfig) => {
            return {
                displayWishlist: customerConfig?.featureFlags?.mzp_wishlist?.enabled ??
                    initialCustomerConfig.displayWishlist,
                displayCoupons: customerConfig?.featureFlags?.mzp_navigation_coupons_overview?.enabled ??
                    initialCustomerConfig.displayCoupons,
                couponsCount: customerConfig?.apis?.couponsCount?.value ?? initialCustomerConfig.couponsCount,
            };
        },
    });
}

export { useAppConfiguration };
//# sourceMappingURL=useAppConfiguration.js.map
